import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import TileLarge from "../TileLarge"
import TileBorderMedium from "../TileBorderMedium"
import TileBorderSmall from "../TileBorderSmall"
import TileSolidSmall from "../TileSolidSmall"
import betterGuide1080w from "images/better-guide-1080w.jpg"
import betterGuide540w from "images/better-guide-540w.jpg"

const LearnMore: React.FC = () => {
  const img = {
    large: {
      src: betterGuide1080w,
      width: "1080w",
    },
    small: {
      src: betterGuide540w,
      width: "540w",
    },
    alt: "The Better Guide",
  }
  return (
    <section className={styles.learnMore}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h3 className={styles.heading}>Understand more, worry less</h3>
        </div>
        <div className={styles.feed}>
          <ul className={styles.grid}>
            <li
              className={cx({
                [styles.item]: true,
                [styles.large]: true,
              })}
            >
              <TileLarge
                heading="The Better Guide to buying a home"
                ctaPrimary="Download now"
                link="/content/the-home-guide/"
                img={img}
              />
            </li>
            <div className={styles.bundle}>
              <li
                className={cx({
                  [styles.item]: true,
                  [styles.medium]: true,
                })}
              >
                <TileBorderMedium
                  heading="Should you opt for a no‑cost mortgage?"
                  ctaPrimary="Try our interactive tool"
                  link="/content/no-cost-mortgage/"
                />
              </li>
              <li
                className={cx({
                  [styles.item]: true,
                  [styles.small]: true,
                })}
              >
                <TileBorderSmall
                  heading="How do you compare loan estimates?"
                  ctaPrimary="Read the guide"
                  link="/content/a-quick-guide-to-your-loan-estimate/"
                />
              </li>
              <li
                className={cx({
                  [styles.item]: true,
                  [styles.small]: true,
                })}
              >
                <TileSolidSmall
                  heading="Are you an Airbnb host?"
                  ctaPrimary="Save on your refi"
                  link="/with/airbnb/"
                />
              </li>
            </div>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default LearnMore
